<agr-page-toolbar
  [pageTitle]="'title' | translate"
  [hasPrimaryAction]="true"
  primaryActionIcon="add"
  [primaryActionText]="'add' | translate"
  (primaryAction)="openApplicationGroupDialog()"
  [isEmpty]="(selectedApplicationGroups$ | async)?.length === 0"
  [emptyTitle]="'no_authorizations' | translate"
  [showEmptyAction]="true"
  emptyActionIcon="add"
  [emptyActionText]="'add' | translate"
  (emptyAction)="openApplicationGroupDialog()"
  emptyActionColor="accent"
>
  @for (group of selectedApplicationGroups$ | async; track group) {
    <section>
      <div class="button-title">
        <h2 class="text--h3 text--light">
          {{ group.displayName }}
        </h2>
        <button (click)="deleteGroupDatastreams(group)" mat-stroked-button color="primary">
          <mat-icon aria-label="Remove">delete</mat-icon> {{ 'remove' | translate }}
        </button>
      </div>
      <mat-table [dataSource]="group.applications">
        <ng-container matColumnDef="name">
          <mat-cell *matCellDef="let application" class="flex__child-1">
            {{ application.displayName }}
          </mat-cell>
        </ng-container>
        <ng-container matColumnDef="set">
          <mat-cell *matCellDef="let application" class="mat-input-cell flex__child-3">
            <mat-form-field class="full-width-field" style="margin-top: 20px">
              <mat-select
                [placeholder]="'data_exchange' | translate"
                [ngModel]="application.dataStreamKeys"
                (ngModelChange)="
                  setApplicationDatastream(application.key, application.dataStreamKeys, $event)
                "
                multiple
              >
                @for (datastream of datastreams$ | async; track datastream) {
                  <mat-option [value]="datastream.key">
                    {{ datastream.displayName }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </mat-cell>
        </ng-container>
        <mat-row
          *matRowDef="let row; columns: ['name', 'set']"
          style="
            border-bottom-color: rgba(0, 0, 0, 0.12);
            border-bottom-style: solid;
            border-bottom-width: 0.8px;
          "
        ></mat-row>
      </mat-table>
    </section>
  }
</agr-page-toolbar>
